import { readMigrationRow } from "@/wallet/migrationCohorts";
import type { MigrationRowExtras } from "@/wallet/migrationCohorts";
import { adminRequest } from "./client";

/**
 * The migration's Spanner row, read on demand: `GET /walletMigrations/{id}` returns the entity
 * whole to an admin (owner-or-admin route, wallet-service ≥ 0.77.0 for the inventory). The console
 * reads it for what the Firestore projection does not carry: `snapshot` (balances, the
 * card-settlement inventory, the assets left behind) and `cardKeysWaiver` (who waived and why).
 *
 * Contract gap: the route's OpenAPI DTO declares `snapshot` with the four balance fields only
 * (`additionalProperties: false`) and no `cardKeysWaiver`; the controller returns the entity, so the
 * extra fields arrive. `readMigrationRow` reads them defensively.
 */
export async function fetchWalletMigrationRow(
  id: string,
  token: string,
  signal?: AbortSignal,
): Promise<MigrationRowExtras> {
  const body = await adminRequest<unknown>({
    method: "GET",
    path: `/walletMigrations/${encodeURIComponent(id)}`,
    token,
    signal,
  });
  return readMigrationRow(body);
}
